import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path key='0' d='M59.2,5c0.7-1.3,0.3-2.9-1-3.6s-2.8-0.2-3.6,1L41.9,24.3c-0.7,1.3-0.3,2.9,1,3.6c1.3,0.7,2.9,0.2,3.6-1.1L59.2,5z' />,
    <path
      key='1'
      d='M35.5,59.3H22.7c-2.4,0-4.2-1.9-4.2-4.2V20.2c0-2.4,1.9-4.2,4.2-4.2h12.9c2.4,0,4.2,1.9,4.2,4.2v34.9
	C39.8,57.4,37.9,59.3,35.5,59.3z'
    />,
  ],
  'TransportCoverOpen'
);

const TransportCoverOpenIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportCoverOpenIcon);
